import { MdLogout } from "react-icons/md";
import { useNavigate } from "react-router-dom";

import { useLogoutUser } from "@/features/auth/services/useLogoutUser";
import { Button } from "@/components/atoms/prime/Button";
import { PathNamekRoutes } from "@/router/constants";

export function LogOutItem() {
  const { mutate } = useLogoutUser();
  const navigate = useNavigate();

  const handleOnClick = () => {
    mutate();
    navigate(PathNamekRoutes.LOGOUT, { replace: true });
  };

  return (
    <Button
      link
      className="cursor-pointer"
      icon={<MdLogout className="hover:fill-primary-600" size={20} />}
      size="small"
      tooltip="Cerrar sesión"
      tooltipOptions={{ position: "left" }}
      onClick={handleOnClick}
    />
  );
}
